export const BRAZE_CUSTOM_EVENTS = {
  ADDED_CLOSED_DATES: 'Added Closed Dates',
  AUTOSYNC_URL_ADDED: 'AutoSync URL Added',
  BUSINESS_PROFILE_UPDATED: 'Business Profile Updated',
  CAMPAIGN_CREATED: 'Campaign Created',
  CALENDAR_PAGE_VIEWED: 'Calendar Page Viewed',
  CALSYNC_INTEGRATION_SYNC: 'Calsync Integration Sync',
  CLASS_CANCELLED: 'Class Cancelled',
  CLASS_SCHEDULE_ADDED: 'Class Schedule Added',
  ENGAGED_WITH_CHAT_BOT: 'Engaged with Chat Bot',
  INTEGRATION_FORM_SUBMITTED: 'Integration Form Submitted',
  MONTHLY_REPORT_DOWNLOADED: 'Monthly Report Downloaded',
  NEW_EQUIPMENT_ADDED: 'New Equipment Added',
  NEW_PRACTITIONER_ADDED: 'New Practitioner Added',
  NEW_SERVICE_ADDED: 'New Service Added',
  OPPORTUNITY_ACCEPT: 'Opportunity Accept',
  OPPORTUNITY_ALL_ACCEPT: 'Opportunity All Accept',
  PASSWORD_CHANGED: 'Password Changed',
  PAYOUT_REPORT_EXPORTED: 'Payout Report Exported',
  PHOTO_ADDED: 'Photo Added',
  REPORT_MEMBER_ISSUE: 'Report Member Issue',
  RESERVATION_REPORT_DOWNLOADED: 'Reservation Report Downloaded',
  SMARTSPOT_ON: 'SmartSpot ON',
  STATS_SECTION_VIEWED: 'Stats Section Viewed',
};

class Braze {
  static hasLoaded = () => {
    if (typeof window !== 'undefined' && window.appboy) {
      return true;
    }
    return false;
  };

  static logCustomEvent = (name, properties) => {
    if (Braze.hasLoaded()) {
      if (properties) {
        window.appboy.logCustomEvent(name, properties);
      } else {
        window.appboy.logCustomEvent(name);
      }
    }
  };

  static trackEvent = (name, properties = null) => Braze.logCustomEvent(name, properties);
}

export default Object.freeze(Braze);
